import React, { useState, useEffect } from 'react';
import { Container, TrustpilotSimpleShort } from '../components';
import { ExternalLink } from './Links';
import { Link } from "gatsby";
import { FaFacebook } from "@react-icons/all-files/fa/FaFacebook";
import { BsTwitterX } from "react-icons/bs";
import { FaLinkedin } from "@react-icons/all-files/fa/FaLinkedin";
import { FaInstagram } from "@react-icons/all-files/fa/FaInstagram";
import { FaYoutube } from "@react-icons/all-files/fa/FaYoutube";
import appStoreIcon from '../images/app/appstore-icon.png';
import googlePlayIcon from '../images/app/googleplay-icon.png';
import CTAAppMob from '../images/CTAAppMob.png';
import { FaPhone } from "@react-icons/all-files/fa/FaPhone";
import { FaEnvelope } from 'react-icons/fa';

function Footer() {

    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <footer className="bg-holborn-app-blue text-holborn-blue">
            <Container className="services">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pt-14 mx-auto">
                    <div className="col-span-full lg:col-start-2 lg:col-end-12">
                        <div className="grid grid-cols-1 md:grid-cols-12 lg:grid-cols-12 gap-10">

                            
                            <div className="footer-col-wrapper md:col-span-4 lg:col-span-4 xl:col-span-2">
                                <p className="text-holborn-blue font-semibold pb-1">Who We Are</p>
                                <ul className="text-holborn-blue text-sm leading-7">
                                    <li className="p-1 md:p-0">
                                    <Link to="/who-we-are/about-us/">About Us</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/who-we-are/our-people/">Our People</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/who-we-are/introducing-the-holborn-app/">Holborn App</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/blog/">Our Blog</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/who-we-are/news/">News & Press</Link>
                                    </li>
                                </ul>
                            </div>
                    
                            <div className="footer-col-wrapper md:col-span-4 lg:col-span-4 xl:col-span-2">
                                <p className="text-holborn-blue font-semibold pb-1">Our Services</p>
                                <ul className="text-holborn-blue text-sm leading-7">
                                    <li className="p-1 md:p-0">
                                    <Link to="/our-services/citizenship-by-investment/">Citizenship by Investment</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/our-services/estate-planning/">Estate Planning</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/our-services/financial-planning/">Financial Planning</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/our-services/investments/">Investments</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/our-services/retirement-planning/">Retirement Planning</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/our-services/wealth-management/">Wealth Management</Link>
                                    </li>
                                </ul>
                            </div>
                    
                            <div className="footer-col-wrapper md:col-span-4 lg:col-span-4 xl:col-span-2">
                                <p className="text-holborn-blue font-semibold pb-1">Contact Us</p>
                                <ul className="text-holborn-blue text-sm leading-7">
                                    <li className="p-1 md:p-0">
                                    <Link to="/contact-us/">Get in touch</Link>
                                    </li>
                                    <li className="p-1 md:p-0">
                                    <Link to="/who-we-are/our-locations/">Our Locations</Link>
                                    </li>
                                </ul>
                            </div>
                    
                            <div className="footer-col-wrapper md:col-span-8 lg:col-span-6  2xl:col-span-6 mb-10 lg:mb-10 md:mt-10 lg:mb-0 xl:mt-10 2xl:mt-20">
                                <div className="col-span-12 relative bg-holborn-white rounded-3xl shadow-xl lg:p-4">
                                    <div className="footer-cta flex flex-col lg:flex-row lg:items-center">
                                    <div className="flex flex-col w-2/3 lg:w-2/4 lg p-4">
                                        <h3 className='text-2xl lg:text-2xl lg:text-3xl xl:text-4xl'>Download the Holborn App</h3>
                                        <p className='text-holborn-mid-blue lg:text-xl xl:text-2xl'>Your money in your pocket</p>
                                        <div className="flex mt-1">
                                        <a href="https://apps.apple.com/gb/app/holborn-assets/id6677055608" target="_blank" rel="noopener noreferrer">
                                            <img src={appStoreIcon} alt="App Store Icon" className="mr-2 w-24 md:w-32 px-1" />
                                        </a>
                                        <a href="https://play.google.com/store/apps/details?id=com.holbornassets.app" target="_blank" rel="noopener noreferrer">
                                            <img src={googlePlayIcon} alt="Google Play icon" className="mr-2 w-24 md:w-32 px-1" />
                                        </a>
                                        </div>
                                    </div>
                                    <div className="absolute bottom-0 right-0 sm:right-10 md:right-8 lg:right-24 transform lg:translate-y-0 lg:translate-x-1/2 2xl:translate-x-1/3">
                                        <img src={CTAAppMob} alt="CTA App Mob" className="w-28 sm:w-40 md:w-40 2xl:w-56" />
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-6 mx-auto">
                    <div className="col-span-full lg:col-start-2 lg:col-end-12">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
                            <div className="col-span-full lg:col-span-3">
                                <div className="text-left">
                                    <p className="text-holborn-blue font-semibold pb-1">Registered Office</p>
                                    <div className="flex flex-wrap text-holborn-blue text-sm">
                                        <p>Holborn Assets Limited Level 7, Building 4.07 King Abdullah Financial District (KAFD) Kingdom of Saudi Arabia (KSA).</p>
                                        <p>Regulator: Ministry of Investment in Saudi Arabia Licence No: 102134208103724</p>
                                    </div>
                                    <div className='text-sm'>
                                        <ul className='flex gap-4'>
                                            <li className="flex">
                                                <FaPhone className="mt-1" />
                                                <a href="tel:+97144573800" className="ml-2 pb-0">
                                                    +971 4 457 3800                             
                                                </a>
                                            </li>
                                            <li className="flex">
                                                <FaEnvelope className="mt-1" />
                                                <a href="mailto:info@holbornassets.com" className="ml-2 pb-0">
                                                    info@holbornassets.com                    
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-full lg:col-span-2 text-left block lg:hidden">
                                <div className="flex space-x-4">
                                    <ExternalLink to="https://www.facebook.com/HolbornAssets/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook">
                                        <FaFacebook className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                    <ExternalLink to="https://twitter.com/holbornassets" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Twitter">
                                        <BsTwitterX className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                    <ExternalLink to="https://www.linkedin.com/company/holborn-assets-llc/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on LinkedIn">
                                        <FaLinkedin className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                    <ExternalLink to="https://www.instagram.com/holbornassets/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram">
                                        <FaInstagram className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                    <ExternalLink to="https://www.youtube.com/@HolbornAssetsLtd" target="_blank" rel="noopener noreferrer" aria-label="Follow us on YouTube">
                                        <FaYoutube className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                </div>
                            </div>
                            <div className="col-span-full lg:col-span-2 flex lg:items-end lg:justify-end">
                                <TrustpilotSimpleShort />
                            </div>
                        </div>
                        <hr className="my-6 border-t-2 border-holborn-light-blue" />
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
                            <div className="col-span-full lg:col-span-4">
                                <div className="text-left lg:flex lg:flex-wrap">
                                    <p className="text-holborn-blue text-sm">© 2024 Holborn Assets Ltd. All rights reserved</p>
                                    <div className="flex flex-wrap text-holborn-blue text-sm ml-2">
                                        <span className='hidden lg:block pr-2'>|</span>
                                        <Link to="/privacy-notice" className="pr-2">Privacy</Link>
                                        <span className="pr-2">|</span>
                                        <Link to="/terms-of-use" className="pr-2">Terms</Link>
                                        <span className="pr-2">|</span>
                                        <Link to="/cookie-policy" className="pr-2">Cookies</Link>
                                        <span className="pr-2">|</span>
                                        <Link to="/complaints" className="pr-2">Complaints</Link>
                                        <span className="pr-2">|</span>
                                        <Link to="/legal-notice" className="pr-2">Legal</Link>
                                        <span className="pr-2">|</span>
                                        <a href="/What-Are-Sustainable-Investments.pdf" target="_blank" rel="noopener noreferrer" className="pr-2">Sustainable Investments</a>
                                    </div>
                                    <p className='text-sm w-4/5'>The information provided in this website is not intended to and do not constitute investment advice or recommendation. No represantation or warranty, express or implied, is made with respect to this website or views herein as to its fairness, accuracy, or completeness.</p>
                                </div>
                            </div>
                            <div className="col-span-full lg:col-span-1 text-right hidden lg:block">
                                <div className="flex justify-end space-x-8">
                                    <ExternalLink to="https://www.facebook.com/HolbornAssets/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Facebook">
                                        <FaFacebook className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                    <ExternalLink to="https://twitter.com/holbornassets" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Twitter">
                                        <BsTwitterX className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                    <ExternalLink to="https://www.linkedin.com/company/holborn-assets-llc/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on LinkedIn">
                                        <FaLinkedin className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                    <ExternalLink to="https://www.instagram.com/holbornassets/" target="_blank" rel="noopener noreferrer" aria-label="Follow us on Instagram">
                                        <FaInstagram className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                    <ExternalLink to="https://www.youtube.com/@HolbornAssetsLtd" target="_blank" rel="noopener noreferrer" aria-label="Follow us on YouTube">
                                        <FaYoutube className="h-6 w-6 text-holborn-blue" />
                                    </ExternalLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;